import { render, staticRenderFns } from "./BeneficiadoForm.vue?vue&type=template&id=6db2d62c"
import script from "./BeneficiadoForm.vue?vue&type=script&lang=js"
export * from "./BeneficiadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports